exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/grid-components/view-attachment-file-no-click/view-attachment-file-no-click.component.scss
// module id = 1914
// module chunks = 66